import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight, Shield } from "lucide-react";

const TRIAL_URL = "https://6vmun24i.forms.app/plumbing-lead-qualification-form";
const DEMO_URL = "https://cal.com/noah-velocitylabs";

export default function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 px-6 md:px-12"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      <div className="max-w-4xl mx-auto text-center" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-[#121212] border border-white/[0.08] rounded-lg">
            <Shield className="w-4 h-4 text-[#5B8DEF]" />
            <span
              className="text-sm text-[#A3A3A3] font-medium"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Zero risk. 3-day free trial. Cancel anytime.
            </span>
          </div>

          <h2
            className="text-3xl md:text-5xl tracking-tighter font-semibold text-white mb-6 leading-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="final-cta-headline"
          >
            Ready to Stop Losing Jobs
            <br />
            <span className="text-[#5B8DEF]">to Missed Calls?</span>
          </h2>

          <p
            className="text-lg text-[#A3A3A3] leading-relaxed mb-10 max-w-2xl mx-auto"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Every day without Velocity Labs is another day of lost revenue. Start your free trial now and see the difference in 72 hours.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <a
              href={TRIAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-trial"
              className="group inline-flex items-center gap-2.5 bg-[#5B8DEF] hover:bg-[#4A79D3] text-white font-semibold px-8 py-4 rounded-lg text-base transition-all duration-200 active:scale-[0.97]"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Start Free 3-Day Trial
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-200" />
            </a>
            <a
              href={DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-demo"
              className="group inline-flex items-center gap-2.5 bg-transparent border border-white/15 hover:border-white/30 text-white font-semibold px-8 py-4 rounded-lg text-base transition-all duration-200 active:scale-[0.97]"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Book a Demo
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
